<template>

  <div class="ProductPrice"
     :class="{'zeborne': isZeborne}">
    <div class="ProductPrice-Status">
      <span class="ProductPrice-infoStatus" v-if="available && shippingInfo.displayStockAvailability">
        EN STOCK
      </span>
      <span class="ProductPrice-infoStatus unavailable" v-else-if="shippingInfo.displayStockAvailability">
        NON DISPONIBLE
      </span>
    </div>
    
    <!-- PROMO PRICE -->
    <div class="ProductPrice-container">
      <!-- PROMO PERCENT -->
      <span v-if="hasPromo && specialPrice" class="ProductPrice-infoSold"> -{{ promoPercent | formatNumber(0) }}% </span>

      <div v-if="hasPromo && specialPrice" class="ProductPrice-infoPrice">
        
        <p class="priceBig" :inner-html.prop="specialPrice | formatPrice(2)"></p>
        <div class="ProductPrice-infoOriginal" v-if="originalPrice">
          <ToolTip :text="priceInfo"  :classProps="'right'"></ToolTip>
          <p class="priceOriginal" :inner-html.prop="originalPrice | formatPrice(2)"></p>
        </div>
      </div>
      <!-- NON PROMO PERCENT -->
      <div v-else class="ProductPrice-infoPrice">
        <p class="priceBig" :inner-html.prop="originalPrice | formatPrice(2)"></p>
      </div>
    </div>
  </div>
</template>

<script>
import PriceMixin from "@/mixins/priceMixin";
import ToolTip from "@/components/ToolTip/ToolTip.vue";
import { mapGetters } from "vuex";
import "@/includes/Product/ProductPrice/ProductPrice.scss";

export default {
  name: "ProductPrice",
  mixins: [PriceMixin],

  components: {
    ToolTip,
  },

  computed: {
    ...mapGetters({ priceInfo: "getProductPriceInfo" }),
    ...mapGetters({ isZeborne: "isZeborne" }),
    ...mapGetters({ shippingInfo: "getProductShippingInfo" }),
  },

  props: {
    available: { Boolean },
  },
};
</script>
